/*
  Pulls a stacked running sale badge (snippets/running-sale-badge, fit: true)
  down into the empty band at the top of the PDP gallery art, so it sits just
  above the product instead of above the whole square.

  For the image currently shown, the art is scanned (via a CORS copy on a
  canvas) for the first non-background row under the badge's columns. If the
  badge fits above it with 8px to spare, it is moved into the image wrapper at
  that height. If not, it stays in its row above the wrapper on image 1 and is
  hidden on other images. Any failure (tainted canvas, no image) leaves the
  safe stacked row as is.
*/
(function () {
  var GAP = 8;
  var TOL = 28; // per-channel difference from the corner colour that counts as art

  function contentTop(img, colFrom, done) {
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var w = 200;
        var h = Math.max(1, Math.round((probe.naturalHeight / probe.naturalWidth) * w));
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext('2d');
        ctx.drawImage(probe, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h).data;
        var x0 = Math.max(0, Math.floor(colFrom * w));
        var bg = [d[(w - 1) * 4], d[(w - 1) * 4 + 1], d[(w - 1) * 4 + 2]];
        for (var y = 0; y < h; y++) {
          for (var x = x0; x < w; x++) {
            var i = (y * w + x) * 4;
            if (d[i + 3] > 16 && (Math.abs(d[i] - bg[0]) > TOL || Math.abs(d[i + 1] - bg[1]) > TOL || Math.abs(d[i + 2] - bg[2]) > TOL)) {
              return done(y / h, probe);
            }
          }
        }
        done(1, probe);
      } catch (e) {
        done(null);
      }
    };
    probe.onerror = function () { done(null); };
    probe.src = img.currentSrc || img.src;
  }

  function fit(badge, wrapper, img, isFirst) {
    var home = badge.rsbHome;
    function stack() {
      if (badge.parentElement !== home.parent) home.parent.insertBefore(badge, home.before);
      badge.classList.remove('running-sale-badge--fitted');
      badge.style.top = '';
      badge.style.visibility = isFirst() ? '' : 'hidden';
    }
    if (!img || !img.naturalWidth) return stack();
    var box = wrapper.getBoundingClientRect();
    var s = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
    var a = { x: (box.width - img.naturalWidth * s) / 2, y: (box.height - img.naturalHeight * s) / 2, w: img.naturalWidth * s, h: img.naturalHeight * s };
    var bw = badge.getBoundingClientRect().width || box.width * 0.28;
    var bh = badge.getBoundingClientRect().height;
    if (!bh) return; // badge image not loaded yet
    // columns the badge covers (right-aligned, 12px in), plus the gap
    var colFrom = (box.width - 12 - bw - GAP - a.x) / a.w;
    contentTop(img, colFrom, function (frac) {
      if (frac === null) return stack();
      var artTop = a.y + frac * a.h;
      var top = artTop - GAP - bh;
      if (top < GAP) return stack();
      if (badge.parentElement !== wrapper) wrapper.appendChild(badge);
      badge.classList.add('running-sale-badge--fitted');
      badge.style.top = top + 'px';
      badge.style.visibility = '';
    });
  }

  function init(badge) {
    if (badge.rsbInit) return;
    badge.rsbInit = true;
    var wrapper = badge.nextElementSibling;
    while (wrapper && !wrapper.classList.contains('pd-main-image-wrapper')) wrapper = wrapper.nextElementSibling;
    if (!wrapper) return;
    var img = wrapper.querySelector('img[id^="pd-img-target-"]');
    if (!img) return;
    badge.rsbHome = { parent: badge.parentElement, before: wrapper };
    var firstSrc = img.getAttribute('src');
    var isFirst = function () { return img.getAttribute('src') === firstSrc; };
    var run = function () { fit(badge, wrapper, img, isFirst); };
    img.addEventListener('load', run);
    var bimg = badge.querySelector('img');
    if (bimg && !bimg.complete) bimg.addEventListener('load', run);
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 150); });
    if (img.complete) run();
  }

  function start() {
    document.querySelectorAll('.running-sale-badge[data-fit]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
